import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "border-b-2 border-gray-200 text-left" }
const _hoisted_3 = {
  scope: "col",
  class: "py-1.5 font-medium"
}
const _hoisted_4 = { class: "py-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "py-1" }
const _hoisted_8 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { QueryResult } from '@/model/Api';


export default /*@__PURE__*/_defineComponent({
  __name: 'DnsRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  columnTitle: {
    type: String,
    required: true,
  },
  recordType: {
    type: String,
    required: true,
  },
  isDomain: {
    type: Boolean,
    default: false,
  },
  canHaveMultipleRecords: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => props.records.response.answer.filter((item) => item.record.recordType === props.recordType));

return (_ctx: any,_cache: any) => {
  return (showRawOutput.value)
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (processedRecords.value.length)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { class: "w-2/3" }),
            _createElementVNode("col", { class: "w-1/3" })
          ], -1)),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_2, [
              _createElementVNode("th", _hoisted_3, _toDisplayString(__props.columnTitle), 1),
              _cache[0] || (_cache[0] = _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Revalidate in", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", _hoisted_4, [
                  (__props.isDomain)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                        _createVNode(DnsRecordsLink, {
                          domain: record.record.raw,
                          class: "text-blue-600 hover:text-blue-800 hover:underline"
                        }, null, 8, ["domain"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(record.record.raw), 1)),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.raw,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, "No " + _toDisplayString(__props.recordType) + " " + _toDisplayString(__props.canHaveMultipleRecords ? 'records' : 'record') + " found.", 1))
}
}

})